module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product18-9f899ce7636c7b388114578ce50b2ed8.jpg";